import {createContext, useContext} from 'react';
import type {AiChatCallbacks} from '@AiChat/callbacks/ai-chat-callbacks.types';

export const NO_AI_CHAT_CALLBACKS: AiChatCallbacks = {};

export const aiChatCallbacksContext = createContext<AiChatCallbacks>(NO_AI_CHAT_CALLBACKS);

export function useAiChatCallbacks(): AiChatCallbacks {
  return useContext(aiChatCallbacksContext);
}
